import {Component, Injectable} from "@angular/core";
import {IonicPage, NavController} from "ionic-angular";

@IonicPage()
@Component({
    selector: 'unauthorized-home-page',
    templateUrl: 'unauthorized-home-page.html'
})

@Injectable()
export class UnauthorizedHomePage {
    constructor(public navCtrl: NavController) {}

}


// WEBPACK FOOTER //
// ./src/pages/unauthorized-home-page/unauthorized-home-page.ts